import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const AddCompanyToPersonRelation = withSuspense(lazy(() => import('./add-c2p')));
export default AddCompanyToPersonRelation;
